module.exports = __webpack_public_path__ + "static/media/fillbucket.50f05220.svg";